exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#header{\n  background: rgb(45,200,187);\n  color: white;\n  font-size: 15px;\n}\n\n.btn-default {\n  color: rgb(45,200,187);\n  min-width: 100%;\n  min-height: 100px;\n  margin:auto;\n  font-size: 40px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/hihoo/ibilling/attendence/public/src/app/attendance-staff/attendance-staff.component.css
// module id = ../../../../../src/app/attendance-staff/attendance-staff.component.css
// module chunks = 1